import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const DeteriorateIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 11 13" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M5.15433 12.5865C5.48916 12.9213 6.03295 12.9213 6.36779 12.5865L10.6537 8.30055C10.9886 7.96571 10.9886 7.42193 10.6537 7.08709C10.3189 6.75225 9.77512 6.75225 9.44028 7.08709L6.61691 9.91314V1.69482C6.61691 1.22069 6.23385 0.837631 5.75972 0.837631C5.28558 0.837631 4.90253 1.22069 4.90253 1.69482V9.91046L2.07915 7.08977C1.74431 6.75493 1.20053 6.75493 0.865693 7.08977C0.530853 7.42461 0.530853 7.96839 0.865693 8.30323L5.15165 12.5892L5.15433 12.5865Z" />
    </SvgIcon>
  )
}
export default DeteriorateIcon
